import { Alert, Button, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '../../store';
import { logout } from '../../store/slices/authSlice';
import { clearTenant } from '../../store/slices/tenantSlice';
import { DEMO_WRITE_BLOCKED_MESSAGE } from '../../utils/demoMode';

function daysLeft(iso?: string | null) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / 86400000);
}

export default function DemoTenantBanner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isDemo, demoExpiresAt, companyName } = useSelector((s: RootState) => s.tenant);
  const userType = useSelector((s: RootState) => s.auth.user?.userType);

  if (!isDemo || userType === 'super_admin') return null;

  const left = daysLeft(demoExpiresAt);
  const expired = left != null && left <= 0;

  if (expired) {
    return (
      <Alert
        severity="error"
        sx={{ borderRadius: 0 }}
        action={(
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              dispatch(logout());
              dispatch(clearTenant());
              navigate('/login');
            }}
          >
            Sign out
          </Button>
        )}
      >
        This sales demo for <strong>{companyName || 'your company'}</strong> has expired. Data is kept — ask the platform team to extend.
      </Alert>
    );
  }

  return (
    <Alert severity="info" sx={{ borderRadius: 0 }}>
      <Stack spacing={0.25}>
        <Typography variant="body2">
          Demo mode{companyName ? ` · ${companyName}` : ''}
          {left != null ? ` · ${left} day${left === 1 ? '' : 's'} left` : ''}
          {demoExpiresAt ? ` (until ${new Date(demoExpiresAt).toLocaleString()})` : ''}.
        </Typography>
        <Typography variant="body2">
          {DEMO_WRITE_BLOCKED_MESSAGE}
        </Typography>
      </Stack>
    </Alert>
  );
}
